module.exports = __webpack_public_path__ + "static/Abacus_Zeugnis_Prozess-571ea9c91ebbbb8ddb9104c4842400e8.png";